import React from 'react';
import { Link, Redirect, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Input } from '@mssgme/ui';
import { useDomain } from './hooks';
import DomainLayout from './DomainLayout';
import Help from './Help';
import config from 'config';

export default function ChangeDNS() {
    const { t } = useTranslation('cards');
    const location = useLocation();
    const domain = useDomain();

    if (domain.resolved) {
        return <Redirect to="/p/settings/domain/disconnect" />;
    }

    return (
        <DomainLayout>
            <Input value={domain.name} disabled />
            <p style={{ marginBottom: 0 }}>
                <Link to={{ pathname: '/p/settings/domain/edit', state: { returnTo: location.pathname } }}>
                    {t('domain.change')}
                </Link>
            </p>
            <Help>
                <p>{t('domain.change_dns')}</p>
                <ol>
                    <li>{t('domain.step_one')}</li>
                    <li>{t('domain.step_two')}</li>
                    <li dangerouslySetInnerHTML={{ __html: t('domain.step_tree') }} />
                </ol>
                <table>
                    <tbody>
                        <tr>
                            <th>{t('domain.th_name')}</th>
                            <td>{domain.subdomain || '@'}</td>
                        </tr>
                        <tr>
                            <th>{t('domain.th_type')}</th>
                            <td>CNAME</td>
                        </tr>
                        <tr>
                            <th>{t('domain.th_value')}</th>
                            <td>{config.cname}.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    {t('domain.any_questions') + ' '}
                    <Link to={{ pathname: '/help', state: { returnTo: location.pathname } }}>
                        {t('domain.contact_us')}
                    </Link>
                </p>
            </Help>
        </DomainLayout>
    );
}
